"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLinkableProjects = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const redux_observable_1 = require("redux-observable");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const Actions = require("../../../actions/vektorio/connect");
const ActionTypes = require("../../../actionTypes/vektorio/connect");
const errorHandling_1 = require("../../../utils/errorHandling");
const validation_1 = require("../../../utils/validation");
const validate = (action) => (0, validation_1.isNotEmpty)('apiKey')(action.payload);
const createRequest = ({ ajax, getToken, baseUrl }, action) => ajax({
    headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
    },
    method: 'POST',
    url: `${baseUrl}api/bim/projects/vektorio/linkable`,
    body: action.payload
}).pipe((0, operators_1.mergeMap)((res) => t
    .array(sok_types_1.Vektorio.iVektorioProject)
    .decode(res.response)
    .fold((e) => (0, rxjs_1.of)(Actions.fetchLinkableFailure((0, errorHandling_1.parseValidationError)(e))), (projects) => (0, rxjs_1.of)(Actions.fetchLinkableSuccess(projects)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchLinkableFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
function fetchLinkableProjects(action$, store, opts) {
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.FETCH_LINKABLE_REQUEST), (0, operators_1.switchMap)((action) => validate(action).fold((e) => (0, rxjs_1.of)(Actions.fetchLinkableValidation((0, validation_1.mapValidationErrors)(e))), () => createRequest(opts, action))));
}
exports.fetchLinkableProjects = fetchLinkableProjects;
//# sourceMappingURL=fetchLinkable.js.map